import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { privacyData } from "./data";
import NewHeader from "../../../Layouts/NewHeader";
import NewFooter from "../../../Layouts/NewFooter";

const Privacy = () => {
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh", overflowX: "hidden" }}
      >
        <NewHeader />
        <div
          className="container"
          style={{ flex: "1", paddingTop: "20px" }}
        >
          <div
            style={{
              fontSize: "18px",
              paddingTop: "10px",
            }}
            className="card px-5 py-5 shadow-lg mt-2 my-3 m-auto"
          >
            <h1
              className="my-2"
              style={{
                color: "#212529",
                fontSize: "32px",
                textTransform: "uppercase",
                fontWeight: 900,
              }}
            >
              Privacy Statement
            </h1>
            {privacyData.map((dd, i) => (
              <section className="mt-2" key={i}>
                <h3 style={{ color: "#212529", fontSize: "22px" }}>
                  {dd.label}
                </h3>

                <p style={{ fontSize: "16px" }}>{dd.value}</p>
              </section>
            ))}
          </div>
        </div>
        <NewFooter />
      </div>
    </>
  );
};

export default Privacy;
